import { CdkDropList } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faHandPointDown } from '@fortawesome/pro-duotone-svg-icons';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GreetingIciTypeEnum } from 'src/app/components/settings/global-settings/greeting-settings/greeting-ici-type-enum';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { AgentGreetingSettingsSelector } from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.selector';
import {
   AgentGreetingItem,
   AgentGreetingItemExpandedState,
   AgentGreetingSettingsState,
   AudioFileInfo,
} from 'src/app/store/settings/agent-greeting-settings/agent-greeting-settings.state';

@Component({
   selector: 'samweb-agent-greeting-wave-drop',
   templateUrl: './agent-greeting-wave-drop.component.html',
   styleUrls: ['./agent-greeting-wave-drop.component.scss'],
})
export class AgentGreetingWaveDropComponent implements OnInit {
   constructor(public store: Store) {}

   @Input()
   public skillId: number;

   @Input()
   public ici: GreetingIciTypeEnum;

   @Input()
   public searchValues: string[];

   @Input()
   public disabled = false;

   @Input()
   public draggedItemKey: AudioFileInfo;

   @Input()
   public connectedLists: CdkDropList[] = [];

   @Output()
   public waveFileDropped = new EventEmitter<AgentGreetingItem>();

   @Output()
   public removeAssignment = new EventEmitter<AgentGreetingItem>();

   @Output()
   public expandGroup = new EventEmitter<AgentGreetingItemExpandedState>();

   public dropIcon: IconDefinition = faHandPointDown;

   public clearIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   public conflictIcon: IconDefinition = WellKnownIconsEnum.GREETING_FILE.iconSmall;

   public notAssignedIcon: IconDefinition = WellKnownIconsEnum.GREETING_FILE_NOT_ASSIGNED.iconSmall;

   public dropZone$: Observable<string>;

   public wave$: Observable<AudioFileInfo>;

   public isConfigConflicting$: Observable<boolean>;
   public configuredWaveCount$: Observable<number>;
   public getAudioFilesForGroup$: Observable<
      {
         iciName: string;
         wave: AudioFileInfo;
      }[]
   >;
   public isExpanded$: Observable<boolean>;
   public IsBaseIci$: Observable<boolean>;

   public isMouseOverComponent = false;

   ngOnInit(): void {
      this.isExpanded$ = this.store.select(AgentGreetingSettingsSelector.isIciExpanded);
      this.IsBaseIci$ = this.store.select(AgentGreetingSettingsSelector.getIsGroupHeader(this.ici.value));

      this.wave$ = this.store.select(AgentGreetingSettingsState.getWaveBySkillAndIci(this.skillId, this.ici.value));
      this.isConfigConflicting$ = this.store.select(AgentGreetingSettingsSelector.getIciConfigIsConflicting(this.skillId, this.ici.value));
      this.configuredWaveCount$ = this.store.select(AgentGreetingSettingsSelector.getConfiguredWaveCount(this.skillId, this.ici.value));
      this.getAudioFilesForGroup$ = this.store.select(AgentGreetingSettingsSelector.getAudioFilesForGroup(this.skillId, this.ici.value));

      this.dropZone$ = this.store.select(AgentGreetingSettingsSelector.getDropZone(this.skillId, this.ici));
   }

   expandIciGroup() {
      this.isMouseOverComponent = false;
      const expandedState = { group: { queueId: this.skillId, iciId: this.ici?.value }, isExpanded: true };
      this.expandGroup.emit(expandedState);
   }

   dropListDroppedId(draggedId: number) {
      this.waveFileDropped.emit({ key: { queueId: this.skillId, iciId: this.ici?.value }, waveId: draggedId });
   }

   clear(wave: AudioFileInfo) {
      this.removeAssignment.emit({ key: { queueId: this.skillId, iciId: this.ici?.value }, waveId: wave?.id });
   }
}
